<template>
    <div>
        <app-dlg
                v-if="shownRelay"
                :show-dlg.sync="shownRelay"
                title="Productivity Change"
                :dlg-width="500"
        >

            <template>
                Changing the productivity label/team membership can change history data. Choose whether you would like to update the history data or only future values.
                <v-checkbox
                        v-model="remember"
                        label="Remember my choice for this session"
                        dense
                        hide-details
                ></v-checkbox>
            </template>

            <template v-slot:actions>
                <v-btn
                        class="ml-2"
                        small
                        color="primary"
                        @click="shownRelay = false"
                        outlined
                        size="small"
                >
                    Cancel
                </v-btn>

                <v-btn
                        @click="makeChoice('future')"
                        small
                        class="ml-2"
                        color="secondary"
                        variant="contained"
                        size="small"
                        outlined
                >
                    Future Only
                </v-btn>

                <v-btn
                        @click="makeChoice('history')"
                        small
                        class="ml-2"
                        color="secondary"
                        variant="contained"
                        size="small"
                >
                    History & Future
                </v-btn>

            </template>
        </app-dlg>
    </div>
</template>

<script>
import AppDlg from "@/components/Shared/AppDlg";
export default {
    components: {AppDlg},
    props: {
        shown: Boolean,
    },
    data() {
        return {
            selfShown: false,
            remember: false
        }
    },
    watch: {
        shown: {
            immediate: true,
            handler(val) {
                this.selfShown = val
            }
        }
    },
    methods: {

        makeChoice(val) {
            if (this.remember)
                this.$store.state.historyPreference = val
            this.$emit(val);
            this.shownRelay = false
        },

        showDlg() {
            this.shownRelay = true
        },
        hideDlg() {
            this.shownRelay = false
        }
    },
    computed: {
        shownRelay: {
            get() {
                return this.selfShown
            },
            set(val) {
                this.selfShown = val
                this.$emit('input:shown', val)
            }
        },
    },
}
</script>

<style scoped>

</style>